import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './CompleteProfileBusiness.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import API from '../../../Utils/Api';
import loader from '../../../assests/loader.gif';

import { validatebusinesscompleteprofile } from '../../../Utils/validate';

import Multiselect from "multiselect-react-dropdown";
import { gettoastwarning, gettoastsuccess } from '../../../Utils/Common';

//import { LoadScript, Autocomplete } from "@react-google-maps/api";


const CompleteProfileBusiness = () => {

     //const [autocomplete, setAutocomplete] = useState(null);

    const [errors, setErrors] = useState({});

    const [loading, setLoading] = useState(true);

    const [inputs, setInputs] = useState({ business_name: '', email: '', contact_number: '', address: '', pincode: '', state: '', city: '', town: '', category_id: '',latitude:'',longitude:'' });

    const [state, setState] = useState([]);
    const [city, setCity] = useState([]);
    const [town, setTown] = useState([]);

    const [category, setCategory] = useState([]);


    useEffect(() => {
        document.title = `Edit Business | Local Bells`;
        document.getElementById('bodywrap').className = 'busieditbusi completebusiness';
        /* Start get profile */
        let formData1 = new FormData();
        formData1.append(`business_id`, localStorage.getItem("business_id"));
        API.post('get_business_detail', formData1)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {
                } else {
                    setInputs({
                        business_name: response.data.data.business_name,
                        email: response.data.data.email,
                        contact_number: response.data.data.business_contact_number,
                        address: response.data.data.address,
                        pincode: response.data.data.pincode,
                        state: response.data.data.state,
                        city: response.data.data.city,
                        town: response.data.data.town,
                        latitude:response.data.data.latitude,
                        longitude:response.data.data.longitude
                    });

                    const ids = response.data.data.categories.map((cat) => cat.id);
                    setInputs(prev => ({ ...prev, category_id: ids }));

                    getCitySel(response.data.data.state);
                    getTownSel(response.data.data.city);
                }
            }).catch(error => {
                setLoading(false);
            });
        /* End get profile */

        API.post('get_state')
            .then(response => {
                setState(response.data.data);
            });


        API.post('get_categories')
            .then(response => {

                if (response.data.status === true) {
                    setCategory(response.data.data);
                } else {

                }
            }).catch(error => {

            });

    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);
    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validatebusinesscompleteprofile(inputs);
        setErrors(validationErrors);

        const generalErrors = Object.keys(validationErrors).filter(
            key => !key.startsWith('hour_')
        );
        const hasGeneralError = generalErrors.length > 0;

        const hourErrorsValid = Object.keys(validationErrors)
            .filter(key => key.startsWith('hour_'))
            .every(key => Object.keys(validationErrors[key]).length === 0);

        const noErrors = !hasGeneralError && hourErrorsValid;

        if (noErrors) {
            setLoading(true);

            let formData = new FormData();
            Object.keys(inputs).forEach((key) => {
                if (key === 'category_id') {
                    formData.append('categories', inputs.category_id.join(','));
                } else {
                    formData.append(key, inputs[key]);
                }
            });
           
            formData.append(`business_id`, localStorage.getItem("business_id"));
            API.post('update_business_profile', formData)
                .then(response => {
                    if (response.data.status === false) {
                        setLoading(false);
                        gettoastwarning(response.data.message, '');
                    } else {
                        setLoading(false);
                        var is_profile_verify2=1;
                        localStorage.setItem("is_profile_verify_buss", is_profile_verify2);
                        gettoastsuccess(response.data.message, '/business/my-deal');
                    }
                }).catch(error => {
                    setLoading(false);
                    gettoastwarning("Something went wrong. Please try again later.", '');
                    //setError("Something went wrong. Please try again later.");
                });
        }
    };

    const getCitySel = (state_id) => {
        let formData = new FormData();
        formData.append('state_id', state_id);
        API.post('get_city', formData)
            .then(response => {

                if (response.data.status === true) {
                    setCity(response.data.data);
                } else {


                }
            }).catch(error => {

            });

    }

    const getTownSel = (city_id) => {
        let formData = new FormData();
        formData.append('city_id', city_id);
        API.post('get_town', formData)
            .then(response => {

                if (response.data.status === true) {
                    setTown(response.data.data);
                } else {


                }
            }).catch(error => {

            });
    }



    const getCity = (event) => {
        event.preventDefault();
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));

        setTown([]);

        var st = 'city';
        var st_val = '';
        setInputs(inputs => ({ ...inputs, [st]: st_val }));

        var ct = 'town';
        var ct_val = '';
        setInputs(inputs => ({ ...inputs, [ct]: ct_val }));

        var ctt = 'category_id';
        var ctt_val = '';
        setInputs(inputs => ({ ...inputs, [ctt]: ctt_val }));

        let formData = new FormData();
        formData.append('state_id', event.target.value);
        API.post('get_city', formData)
            .then(response => {

                if (response.data.status === true) {
                    setCity(response.data.data);
                } else {


                }
            }).catch(error => {

            });

    }

    const getTown = (event) => {
        event.preventDefault();
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
        setTown([]);

        var ct = 'town';
        var ct_val = '';
        setInputs(inputs => ({ ...inputs, [ct]: ct_val }));

        var ctt = 'category_id';
        var ctt_val = '';
        setInputs(inputs => ({ ...inputs, [ctt]: ctt_val }));
        let formData = new FormData();
        formData.append('city_id', event.target.value);
        API.post('get_town', formData)
            .then(response => {

                if (response.data.status === true) {
                    setTown(response.data.data);
                } else {


                }
            }).catch(error => {

            });
    }
    const getCat = (event) => {
        event.preventDefault();
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
        get_town_picode(event.target.value);
    }
    const get_town_picode = (id) => {
        let formData = new FormData();
        formData.append('town_id', id);
        API.post('get_town_pincode', formData)
            .then(response => {

                if (response.data.status === true) {
                    if (response.data.data.city_id !== '') {
                        var pincode_label = 'pincode';
                        var pincode_val = response.data.data.pincode;
                        setInputs(inputs => ({ ...inputs, [pincode_label]: pincode_val }));
                    }
                } else {

                }
            }).catch(error => {

            });
    }
    const getpicode_town = () => {
        if (inputs.pincode !== '') {
            let formData = new FormData();
            formData.append('pin_code', inputs.pincode);
            API.post('get_pincode_town', formData)
                .then(response => {

                    if (response.data.status === true) {
                        if (response.data.data.city_id !== '' && response.data.data.state_id !== '') {
                            setCity(response.data.data.city);
                            setTown(response.data.data.town);
                            var state_label = 'state';
                            var state = response.data.data.state_id;
                            setInputs(inputs => ({ ...inputs, [state_label]: state }));

                            var city_label = 'city';
                            var city = response.data.data.city_id;
                            setInputs(inputs => ({ ...inputs, [city_label]: city }));

                            var town_label = 'town';
                            var town = response.data.data.town_id;
                            setInputs(inputs => ({ ...inputs, [town_label]: town }));

                            var town_text=response.data.data.town_name;
                            var town_name_lbl="town_name";
                            setInputs(inputs => ({ ...inputs, [town_name_lbl]: town_text }));
                        }else{
                            setCity([]);
                            setTown([]);
                            var state_label3 = 'state';
                            var state3 = '';
                            setInputs(inputs => ({ ...inputs, [state_label3]: state3 }));

                            var city_label3 = 'city';
                            var city3 = '';
                            setInputs(inputs => ({ ...inputs, [city_label3]: city3 }));

                            var town_label3 = 'town';
                            var town3 = '';
                            setInputs(inputs => ({ ...inputs, [town_label3]: town3 }));

                            var town_text3='';
                                var town_name_lbl3="town_name";
                                setInputs(inputs => ({ ...inputs, [town_name_lbl3]: town_text3 }));
                        }
                    } else {
                        setCity([]);
                        setTown([]);
                        var state_label1 = 'state';
                        var state1 = '';
                        setInputs(inputs => ({ ...inputs, [state_label1]: state1 }));

                        var city_label1 = 'city';
                        var city1 = '';
                        setInputs(inputs => ({ ...inputs, [city_label1]: city1 }));

                        var town_label1 = 'town';
                        var town1 = '';
                        setInputs(inputs => ({ ...inputs, [town_label1]: town1 }));

                        var town_text1='';
                            var town_name_lbl1="town_name";
                            setInputs(inputs => ({ ...inputs, [town_name_lbl1]: town_text1 }));
                    }
                }).catch(error => {

                });
        }else{
            setCity([]);
            setTown([]);
            var state_label2 = 'state';
            var state2 = '';
            setInputs(inputs => ({ ...inputs, [state_label2]: state2 }));

            var city_label2 = 'city';
            var city2 = '';
            setInputs(inputs => ({ ...inputs, [city_label2]: city2 }));

            var town_label2 = 'town';
            var town2 = '';
            setInputs(inputs => ({ ...inputs, [town_label2]: town2 }));

            var town_text2='';
            var town_name_lbl2="town_name";
            setInputs(inputs => ({ ...inputs, [town_name_lbl2]: town_text2 }));
        }
    }
    /* Start Value set */
    const handleInputChange = (event) => {
        event.persist();
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
    }
    const handleInputChangeMo = (event) => {
        event.persist();
        const { name, value } = event.target;

        // Allow only numbers (0–9)
        const regex = /^[0-9]*$/;

        if (regex.test(value)) {
            setInputs(inputs => ({ ...inputs, [name]: value }));
        }
    }
    const handleInputChangeSpe = (event) => {
        event.persist();
        const { name, value } = event.target;

        // Allow only letters, numbers, spaces, and basic punctuation if needed
        const regex = /^[a-zA-Z0-9\s]*$/;

        if (regex.test(value)) {
            setInputs(inputs => ({ ...inputs, [name]: value }));
        }
    }
    /* End Value set */
    const handleCategorySelect = (selectedList) => {
        const ids = selectedList.map(lang => lang.id);
        setInputs(prev => ({ ...prev, category_id: ids }));
        setTimeout(() => {
            document.querySelector(".custom-multiselect input")?.blur();
        }, 50);
    };

    const handleCategoryRemove = (selectedList) => {
        const ids = selectedList.map(lang => lang.id);
        setInputs(prev => ({ ...prev, category_id: ids }));
    };


     //const onLoad = (auto) => setAutocomplete(auto);

  /*const onPlaceChanged = () => {
    if (!autocomplete) return;

    const place = autocomplete.getPlace();

    var albl = 'address';
    setInputs(inputs => ({ ...inputs, [albl]: place.formatted_address }));
    
    if (place.geometry && place.geometry.location) {

        var latlbl = 'latitude';
        setInputs(inputs => ({ ...inputs, [latlbl]: place.geometry.location.lat() }));

        var longlbl = 'longitude';
        setInputs(inputs => ({ ...inputs, [longlbl]: place.geometry.location.lng() }));

      
    }

  };

  const handleChange = (e) => {
    setInputs((prev) => ({
      ...prev,
      address: e.target.value,
    }));
  };*/

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <div className='white-box business-form'>

                                    <Row className='mb-3'>
                                        <div className="d-flex align-items-start justify-content-end gap-3">
                                            
                                        </div>
                                        <Col md={12} lg={12} xl={5}>
                                            <h3>Complete Business Profile</h3>
                                        </Col>
                                        
                                    </Row>
                                    <Form onSubmit={handleSubmit}>
                                        <Row>
                                            <Col md={12} lg={12} xl={5}>

                                                <Form.Group className="mb-3">
                                                    <Form.Label className=''>Business Name</Form.Label>
                                                    <Form.Control type="text" placeholder="Business Name" name="business_name" onChange={handleInputChangeSpe} value={inputs.business_name} maxLength="50" />
                                                </Form.Group>
                                                {errors.business_name && (<p className="text-danger">{errors.business_name}</p>)}
                                                <Form.Group className="mb-3">
                                                    <Form.Label className=''>Business Email</Form.Label>
                                                    <Form.Control type="text" placeholder="Business Email" value={inputs.email} disabled />
                                                </Form.Group>
                                                {errors.email && (<p className="text-danger">{errors.email}</p>)}
                                                <Form.Label className=''>Contact Number</Form.Label>
                                                <InputGroup className="anb-cont mb-3">
                                                    <Form.Control
                                                        placeholder="Contact No"
                                                        aria-label="cntno"
                                                        aria-describedby="cntno"
                                                        type="text"
                                                        name="contact_number" onChange={handleInputChangeMo} value={inputs.contact_number}
                                                        maxLength={15}
                                                    />
                                                    {/*<InputGroup.Text id="cntno">
                                                        <Link to="/">Verify phone number</Link>
                                                    </InputGroup.Text>*/}
                                                </InputGroup>
                                                {errors.contact_number && (<p className="text-danger">{errors.contact_number}</p>)}
                                                

                                            </Col>
                                            <Col md={12} lg={12} xl={7}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className=''>Pin code</Form.Label>
                                                    <Form.Control type="text" placeholder="Pin code" name="pincode" onChange={handleInputChangeMo} onBlur={getpicode_town} value={inputs.pincode} maxLength={6} />
                                                </Form.Group>
                                                {errors.pincode && (<p className="text-danger">{errors.pincode}</p>)}
                                                <Row>
                                                    <Col md={4}>
                                                        <Form.Label className=''>State</Form.Label>
                                                        <Form.Select aria-label="Default select example" name="state" onChange={getCity} value={inputs.state}>
                                                            <option value="">State</option>
                                                            {state && state.map((val, index) => {
                                                                return (
                                                                    <option value={val.id}>{val.name}</option>
                                                                )
                                                            })}
                                                        </Form.Select>
                                                        {errors.state && (<p className="text-danger">{errors.state}</p>)}
                                                    </Col>
                                                    <Col md={4}>
                                                    <Form.Label className=''>City</Form.Label>
                                                        <Form.Select aria-label="Default select example" name="city" onChange={getTown} value={inputs.city}>
                                                            <option value="">City</option>
                                                            {city && city.map((val, index) => {
                                                                return (
                                                                    <option value={val.id}>{val.name}</option>
                                                                )
                                                            })}
                                                        </Form.Select>
                                                        {errors.city && (<p className="text-danger">{errors.city}</p>)}
                                                    </Col>
                                                    <Col md={4}>
                                                    <Form.Label className=''>Locality</Form.Label>
                                                        <Form.Select aria-label="Default select example" name="town" onChange={getCat} value={inputs.town}>
                                                            <option value="">Locality</option>
                                                            {town && town.map((val, index) => {
                                                                return (
                                                                    <option value={val.id}>{val.name}</option>
                                                                )
                                                            })}
                                                        </Form.Select>
                                                        {errors.town && (<p className="text-danger">{errors.town}</p>)}
                                                    </Col>
                                                </Row>
                                                {/*<div className="mb-3">
                                                    <Form.Label className=''>Business Address</Form.Label>
                                                <LoadScript
                                                  googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                                                  libraries={["places"]}
                                                  version="weekly"
                                                >
                                                  <Autocomplete
                                                    onLoad={onLoad}
                                                    onPlaceChanged={onPlaceChanged}
                                                    options={{
                                                      types: ["geocode"],
                                                      componentRestrictions: { country: "in" }
                                                    }}
                                                  >
                                                    <input
                                                      type="text"
                                                      placeholder="Enter address"
                                                      className="form-control"
                                                      value={inputs.address}
                                                      onChange={handleChange}
                                                    />
                                                  </Autocomplete>
                                                </LoadScript>
                                                {errors.address && (<p className="text-danger">{errors.address}</p>)}
                                            </div>*/}
                                                <div className="mb-3">
                                                    <Form.Label className=''>Business Address</Form.Label>
                                                    <Form.Control as="textarea" rows={3} placeholder='Address' name="address" onChange={handleInputChange} value={inputs.address} />
                                                   
                                                </div>
                                                <Form.Label className=''>Category</Form.Label>
                                                <div className="position-relative">
                                                    <div className="multi-drop-box">
                                                        X
                                                    </div>
                                                    <Multiselect
                                                        options={category}
                                                        selectedValues={category.filter(lang => inputs.category_id.includes(lang.id))}
                                                        onSelect={handleCategorySelect}
                                                        onRemove={handleCategoryRemove}
                                                        placeholder="Select Category"
                                                        className="custom-multiselect"
                                                        displayValue="name"
                                                        showArrow={false}
                                                    />
                                                </div>
                                                {errors.category_id && (<p className="text-danger">{errors.category_id}</p>)}

                                               



                                                <div className='yellow-note'>
                                                    <h6>Tag upto 10 categories. Your business will be shown in search when users search for business with one of your selected categories</h6>
                                                </div>


                                                <Button variant="primary" type="submit" className='orange-btn'>
                                                    <h6>Save</h6>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                                <div className='footer-org footer'>
                                    <Footer />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {loading && (
                <div className="loadingClass">
                    <img src={loader} alt="loader" />
                </div>
            )}
        </>
    )
}

export default CompleteProfileBusiness;


